<script lang="ts">
	import MarkdownContent from '$lib/components/docs/MarkdownContent.svelte';
	import type { PageData } from './$types';

	// Content is provided server-side (+page.server.ts) so the H1 is in the
	// prerendered HTML for crawlers.
	let { data }: { data: PageData } = $props();
	const content = $derived(data.content);
</script>

<svelte:head>
	<title>Troubleshooting - Heyweek Documentation</title>
	<meta name="description" content="Solutions to common issues in Heyweek - troubleshoot login problems, performance issues, sync errors, and more." />
	<meta property="og:title" content="Troubleshooting - Heyweek Documentation" />
	<meta property="og:description" content="Solutions to common issues in Heyweek - troubleshoot login problems, performance issues, sync errors, and more." />
</svelte:head>

<MarkdownContent {content} />